import { GameFilterOptionType, GamesFilterTypeEnum } from './config'

// Payload config
const GameSortTypeEnum = {
  GameSortTypePopularity: 1,
  GameSortTypeNew: 2,
  GameSortTypeName: 3,
  GameSortTypeRTP: 4,
  GameSortTypeRecommended: 5,
}

const GameSortOrderEnum = {
  GameSortOrderAsc: 1,
  GameSortOrderDesc: -1,
}

export const mapSortType = (filter: GameFilterOptionType) => {
  switch (filter.key) {
    case GamesFilterTypeEnum.Popularity:
      return {
        gameSortType: GameSortTypeEnum.GameSortTypePopularity,
        gameSortOrder: GameSortOrderEnum.GameSortOrderDesc,
      }
    case GamesFilterTypeEnum.New:
      return {
        gameSortType: GameSortTypeEnum.GameSortTypeNew,
        gameSortOrder: GameSortOrderEnum.GameSortOrderDesc,
      }
    case GamesFilterTypeEnum.RTP:
      return {
        gameSortType: GameSortTypeEnum.GameSortTypeRTP,
        gameSortOrder: GameSortOrderEnum.GameSortOrderDesc,
      }
    case GamesFilterTypeEnum.NameAsc:
      return {
        gameSortType: GameSortTypeEnum.GameSortTypeName,
        gameSortOrder: GameSortOrderEnum.GameSortOrderAsc,
      }
    case GamesFilterTypeEnum.NameDesc:
      return {
        gameSortType: GameSortTypeEnum.GameSortTypeName,
        gameSortOrder: GameSortOrderEnum.GameSortOrderDesc,
      }
    case GamesFilterTypeEnum.Recommended:
      return {
        gameSortType: GameSortTypeEnum.GameSortTypeRecommended,
        gameSortOrder: GameSortOrderEnum.GameSortOrderAsc,
      }
    default:
      return {
        gameSortType: GameSortTypeEnum.GameSortTypePopularity,
        gameSortOrder: GameSortOrderEnum.GameSortOrderDesc,
      }
  }
}
